import React from "react";
import BusinessForm from "./BusinessForm";
import { Modal } from "antd";

export default function BusinessFormModal({ open, onCancel }) {
    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            width={"900px"}
            style={{ top: "50px" }}
            maskClosable={false}
            keyboard={true}
            closable={true}
        >
            <BusinessForm onDone={onCancel} />
        </Modal>
    );
}
